import React, { 
    Component,
    PropTypes,
} from 'react'

import ProfileCard from './profile_card'
import sliderData from './slider_data'
import SunMoonPlot from './sun_moon_plot'
import GradientBackground from './gradient_background'
import IntroductionChart from './introduction_chart'

const intervalTime = 10000

const generateArrayData = ({length, min, max}) => {
  return _.times(length, _.random.bind(null, min, max))
}

class Slider extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      position: 0,
      degree: 0,
      chartDatasets: [
        generateArrayData({length: 25, min: 10, max: 20}),
        generateArrayData({length: 25, min: 10, max: 20})
      ]
    }
    this._toPrev = this.toPrev.bind(this)
    this._toNext = this.toNext.bind(this)
    this._startInterval = this.startInterval.bind(this)
    this._clearInterval = this.clearInterval.bind(this)
  }

  componentWillMount(){
    this.intervals = []
  }

  setInterval(){
    this.intervals.push(setInterval.apply(null, arguments))
  }

  componentWillUnmount(){
    this.clearInterval()
  }
  componentDidMount() {
    this.startInterval()
  }

  startInterval(){
    let intervalDegreeTime = intervalTime / (90 / sliderData.data.length)
    let intervalIdA = setInterval(this.tickDegree.bind(this), intervalDegreeTime)
    let intervalIdB = setInterval(this.tickPosition.bind(this), intervalTime)
    let intervalIdC = setInterval(this.tickCharts.bind(this), intervalTime)
    this.setState({intervalIdA, intervalIdB, intervalIdC})
  }

  clearInterval(){
    clearInterval(this.state.intervalIdA)
    clearInterval(this.state.intervalIdB)
    clearInterval(this.state.intervalIdC)
  }

  tickDegree(){
    this.setState({degree: this.state.degree + 4})
  }

  tickPosition(){
    let position = this.getNextPosition()
    this.setState({position})
  }

  getChartDatasets(){
    let {chartDatasets} = this.state
    
    let t = _.map(chartDatasets, (set, i) => {
      let min = 10
      let max = 20
      let length = 25
      if(i === 0){min = 4}
      return generateArrayData({length, min, max})
    })
    return t
  }

  tickCharts(){
    let chartDatasets = this.getChartDatasets()
    this.setState({chartDatasets}) 
  }

  getNextPosition(){
    let position = this.state.position
    position++
    if(position > (sliderData.data.length - 1)){
      position = 0
    }
    return position
  }

  getPrevPosition(){
    let position = this.state.position
    position--
    if(position < 0){
      position = sliderData.data.length - 1
    }
    return position
  }

  getPrevDegree(position){
    let gap = 360 / sliderData.data.length
    let fixedPosition = gap * position
    let rounds = Math.floor(this.state.degree / 360)
    if(position > this.state.position){
      rounds = rounds - 1
    }
    return rounds * 360 + fixedPosition
  }

  getNextDegree(position){
    let gap = 360 / sliderData.data.length
    let fixedPosition = gap * position
    let rounds = Math.floor(this.state.degree / 360)
    if(position < this.state.position){
      rounds = rounds + 1
    }

    return rounds * 360 + fixedPosition
  }

  toPrev(){
    let position = this.getPrevPosition()
    let degree = this.getPrevDegree(position)
    let chartDatasets = this.getChartDatasets()
    this.setState({position, degree, chartDatasets})
    this._clearInterval()
    setTimeout(this._startInterval, 500)
  }

  toNext(){
    let position = this.getNextPosition()
    let degree = this.getNextDegree(position)
    let chartDatasets = this.getChartDatasets()
    this.setState({position, degree, chartDatasets})
    this._clearInterval()
    setTimeout(this._startInterval, 500)
  }

  render(){
    let {position, degree} = this.state
    let prevPosition = this.getPrevPosition()
    let nextPosition = this.getNextPosition()
    let profileCards = _.map(sliderData.data, (data, i) => {
      return <ProfileCard 
        position={position}
        prevPosition={prevPosition}
        nextPosition={nextPosition}
        data={data} 
        order={i}
        key={i}/>
    })
    let introductionCharts = _.map(this.state.chartDatasets, (data, i) => {
      return <IntroductionChart stage={i} data={data} key={i}/>
    })
    return <div className='slider-container'>
      <GradientBackground degree={degree}/>
      <div className='profile-cards'>
        {profileCards}
      </div>
      <SunMoonPlot 
        dataLength={sliderData.data.length}
        position={position} 
        degree={degree}/>
      <div className='switch-btns'>
        <div className='btn-prev' onClick={this._toPrev}></div>
        <div className='btn-next' onClick={this._toNext}></div>
      </div>
      <div className='introduction-charts'>
        {introductionCharts}
      </div>  
    </div>
  }
}

module.exports = Slider


/** WEBPACK FOOTER **
 ** assets/javascripts/introduction/slider.js
 **/